import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { ProductGrid } from '../product/ProductGrid';
import styles from './InfiniteScroll.module.scss';
export function InfiniteScroll({ products, loading, layout, mode = 'auto', hasMore = false, onLoadMore, bannerConfig }) {
    const loaderRef = useRef(null);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    // Auto mode: load more when scrolled to bottom
    useEffect(() => {
        if (mode !== 'auto' || !hasMore || !onLoadMore || isLoadingMore)
            return;
        const handleScroll = () => {
            if (!loaderRef.current)
                return;
            const rect = loaderRef.current.getBoundingClientRect();
            // Load more when loader is visible
            if (rect.top < window.innerHeight && !isLoadingMore) {
                setIsLoadingMore(true);
                onLoadMore();
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Check immediately in case already in view
        return () => window.removeEventListener('scroll', handleScroll);
    }, [mode, hasMore, onLoadMore, isLoadingMore]);
    // Reset loading state when products change
    useEffect(() => {
        setIsLoadingMore(false);
    }, [products.length]);
    const handleLoadMore = () => {
        if (onLoadMore && hasMore && !isLoadingMore) {
            setIsLoadingMore(true);
            onLoadMore();
        }
    };
    return (h("div", null,
        h(ProductGrid, { products: products, loading: loading && products.length === 0, layout: layout, bannerConfig: bannerConfig }),
        hasMore && mode === 'button' && (h("button", { onClick: handleLoadMore, disabled: isLoadingMore, className: styles.loadMoreButton }, isLoadingMore ? 'Loading...' : 'Load More')),
        hasMore && mode === 'auto' && (h("div", { ref: loaderRef, style: { height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' } }, isLoadingMore ? (h("div", { style: { textAlign: 'center' } },
            h("div", { style: {
                    width: '40px',
                    height: '40px',
                    border: '3px solid #f3f3f3',
                    borderTop: '3px solid #007bff',
                    borderRadius: '50%',
                    margin: '0 auto',
                    animation: 'spin 1s linear infinite'
                } }),
            h("p", { style: { marginTop: '10px' } }, "Loading more products..."))) : (h("p", null, "Scroll for more...")))),
        h("style", null, `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `)));
}
